export default "__VITE_ASSET__C3vx$rPQ__"